const {
  REACT_APP_API_AUTH_URL = 'http://localhost:8080/v1/auth',
  REACT_APP_API_URL = 'http://localhost:8080/v1/api',
} = process.env;

export const API_AUTH_PROVIDERS_URL = `${REACT_APP_API_AUTH_URL}/oauth2/_providers`;
export const API_AUTH_CREDENTIALS_URL = `${REACT_APP_API_AUTH_URL}/local/credentials`;
export const API_AUTH_LOGIN_URL = `${REACT_APP_API_AUTH_URL}/local/login`;
export const API_AUTH_TOKEN_URL = `${REACT_APP_API_AUTH_URL}/token`;

export const API_TOP_LEVEL_RESOURCE_ALL_URL = `${REACT_APP_API_URL}/{resource}`;
export const API_TOP_LEVEL_RESOURCE_ONE_URL = `${REACT_APP_API_URL}/{resource}/{id}`;
export const API_TOP_LEVEL_RESOURCE_APPROVE_URL = `${API_TOP_LEVEL_RESOURCE_ONE_URL}/approve`;

export const API_CONFIGS_URL = `${REACT_APP_API_URL}/configs`;
export const API_CONFIG_URL = `${REACT_APP_API_URL}/configs/{configId}`;

export const API_USERS_URL = `${REACT_APP_API_URL}/users`;
export const API_USER_TRUSTED_CONTACT_URL = `${REACT_APP_API_URL}/users/{userId}/{accountNumber}`;

export const API_USER_URL = `${REACT_APP_API_URL}/users/{userId}`;
export const API_USER_EMPLOYMENT_URL = `${REACT_APP_API_URL}/users/{userId}/employment`;
export const API_USER_DISCLOSURES_URL = `${REACT_APP_API_URL}/users/{userId}/disclosures`;
export const API_USER_DOWNLOAD_ALL_URL = `${REACT_APP_API_URL}/users/{userId}/downloads`;
export const API_USER_DOWNLOAD_ONE_URL = `${REACT_APP_API_URL}/users/{userId}/downloads/{type}/{reportId}`;
export const API_USER_FILES_ONE_URL = `${REACT_APP_API_URL}/users/{userId}/files/{name}`;
export const API_USER_CHANGE_STATUS_URL = `${API_USER_URL}/status`;

export const API_ACCOUNTS_URL = `${REACT_APP_API_URL}/accounts`;
export const API_ACCOUNT_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}`;
export const API_ACCOUNT_OFFER_ORDERS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/offer-orders`;
export const API_ACCOUNT_CASH_BALANCE_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/cash-balance`;
export const API_ACCOUNT_POSITIONS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/positions`;
export const API_ACCOUNT_PERFORMANCE_RAW_DATA_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/performance-raw-data`;
export const API_ACCOUNT_PERFORMANCE_SUMMARY_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/performance-summary`;
export const API_ACCOUNT_BANK_LINKS_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/bank-links`;
export const API_ACCOUNT_BANK_LINK_URL = `${REACT_APP_API_URL}/accounts/{accountNumber}/bank-links/{bankLinkId}`;
export const API_OFFERINGS_URL = `${REACT_APP_API_URL}/offerings`;
export const API_OFFERING_URL = `${REACT_APP_API_URL}/offerings`;
export const API_OFFERING_ACTIONS_URL = `${REACT_APP_API_URL}/offering-actions`;
export const API_ACCOUNT_CLOSE_ACCOUNT_URL = `${REACT_APP_API_URL}/accounts/{userId}/closeAccount`;

export const API_QUOTES_SNAPQUOTES_URL = `${REACT_APP_API_URL}/quotes/snap-quotes/{symbols}`;
export const API_QUOTES_CHARTDATA_URL = `${REACT_APP_API_URL}/quotes/chart-data/{symbols}/?start={startDate}&interval={interval}`;
export const API_QUOTES_PRIVATE_QUOTES_ALL_URL = `${REACT_APP_API_URL}/quotes/private-quotes`;
export const API_QUOTES_PRIVATE_QUOTES_URL = `${REACT_APP_API_URL}/quotes/private-quotes/{id}`;
export const API_QUOTES_PRIVATE_QUOTES_URL_EDITFORMAT = `${REACT_APP_API_URL}/quotes/private-quotes/{id}/edit`;
export const API_QUOTES_PRIVATE_QUOTES_FOLIO_URL = `${REACT_APP_API_URL}/quotes/fetch/private-quotes`;

export const API_OFFERING_ORDER_URL = `${API_ACCOUNT_URL}/offer-orders`;
export const API_OFFER_ORDER_URL = `${REACT_APP_API_URL}/offering-orders/{offerOrderId}`;
export const API_UPLOAD_OFFER_ORDERS_FOLIO_URL = `${REACT_APP_API_URL}/offering-orders/offers/folio`;

export const API_OFFERING_DOCUMENTS_URL = `${REACT_APP_API_URL}/offering-documents`;
export const API_OFFERING_DOCUMENT_URL = `${API_OFFERING_DOCUMENTS_URL}/{offeringDocumentId}`;

export const API_OFFERING_SUBSCRIPTIONS_URL = `${API_ACCOUNT_URL}/offeringSubscriptions`;
export const API_OFFERING_SUBSCRIPTION_URL = `${API_ACCOUNT_URL}/offeringSubscriptions/{offeringSubscriptionId}`;

export const API_OFFER_CAMPAIGNS_URL = `${REACT_APP_API_URL}/offering-campaigns`;
export const API_OFFER_CAMPAIGN_URL = `${API_OFFER_CAMPAIGNS_URL}/{campaignId}`;
export const API_OFFER_CAMPAIGN_SEND_URL = `${API_OFFER_CAMPAIGNS_URL}/{campaignId}/send`;
export const API_OFFER_CAMPAIGN_TEST_SEND_URL = `${API_OFFER_CAMPAIGNS_URL}/{campaignId}/test`;
export const API_OFFER_CAMPAIGN_EVALUATE_URL = `${API_OFFER_CAMPAIGNS_URL}/{campaignId}/eval`;
export const API_OFFER_EMAILS_URL = `${API_OFFERINGS_URL}/{offerId}/emails`;

export const API_PLAID_LINK_SETTINGS_URL = `${REACT_APP_API_URL}/users/{userId}/bank-links/plaid/link-settings`;
export const API_FOLIO_URLS = `${REACT_APP_API_URL}/folio`;
export const API_UPLOAD_TOKEN_URL = `${REACT_APP_API_URL}/uploads/token`;

export const API_SEND_RESET_PASSWORD_URL = `${REACT_APP_API_AUTH_URL}/local/credentials/reset-request`;

export const API_ADMIN_STATISICS_URL = `${REACT_APP_API_URL}/admin/statistics`;
export const API_ADMIN_CHART_DATA_URL = `${REACT_APP_API_URL}/admin/chart-data`;
export const API_NOTIFICATIONS_URL = `${REACT_APP_API_URL}/notifications/notifications`;
export const API_NOTIFICATION_REGISTRATIONS_URL = `${REACT_APP_API_URL}/notifications/registrations`;

export const API_EMAIL_TEMPLATES = `${REACT_APP_API_URL}/email-templates`;
export const API_EMAIL_TEMPLATE = `${REACT_APP_API_URL}/email-templates/{id}`;
export const API_MAILCHIMP_URLS = `${REACT_APP_API_URL}/mailchimp`;

export const API_EXTERNAL_OFFER_ORDERS_URL = `${REACT_APP_API_URL}/external-offering-orders`;

export const API_SOLICITED_USERS = `${REACT_APP_API_URL}/solicited-users`;

export const EXTERNAL_OFFER_ORDER_STATUS_EMAIL = `${REACT_APP_API_URL}/{resource}/{id}/status-email`;

/**
 * Replaces placeholders in the string with values from mapObj
 * @example
 *   str = 'Hello {name}, today is {today}'
 *   name = 'Alice';
 *   today: 'Monday',
 *   replacePlaceholders(str, { name, today })
 *
 * Returns 'Hello Alice, today is Monday'
 *
 * Based on https://stackoverflow.com/a/15604206
 */
export const replacePlaceholders = (str, mapObj) => {
  if (!mapObj) {
    return str;
  }
  return str.replace(
    new RegExp(Object.keys(mapObj).map(key => `{${key}}`).join('|'), 'gi'),
    matched => mapObj[matched.substring(1, matched.length - 1)],
  );
};



// WEBPACK FOOTER //
// ./src/urls.js